'use client';

import type Error from 'next/error';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import ErrorComponent from '@/components/ErrorComponent';
export interface ErrorProps {
  error: Error & {
    digest?: string;
  };
}
export default function GlobalError({
  error
}: ErrorProps) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: {
        'error-component': 'global-error'
      }
    });
  }, [error]);
  return <body data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <ErrorComponent error={error} data-sentry-element="ErrorComponent" data-sentry-source-file="global-error.tsx" />
    </body>;
}